var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pdfByteArray)?_c('div',{staticClass:"pdf-wrapper"},[_c('m-pdf-viewer',{attrs:{"type":"templates","src":_vm.pdfByteArray,"item":_vm.template}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }